/*
 * Copyright (c) 2024. . Yantodev - All Rights Reserved.
 * @Author  :  yantodev
 * mailto : ekocahyanto007@gmail.com
 * link : https://yantodev.my.id/
 */

import {
    REQUEST_MASTER_COMPANY,
    REQUEST_MASTER_COMPANY_FAILURE,
    REQUEST_MASTER_COMPANY_SUCCESS
} from "../../../constant/MasterCompanyConstant";

const initialState = {
    masterCompany: {
        data: [],
        isLoading: true,
        status: 'idle'
    },
}

export const masterCompanyReducer = (state = initialState, action) => {
    const {type, payload} = action;
    switch (type) {
        case REQUEST_MASTER_COMPANY:
            return {
                ...state,
                masterCompany: {
                    data: [],
                    isLoading: true,
                    status: 'fetching'
                }
            };
        case REQUEST_MASTER_COMPANY_SUCCESS:
            return {
                ...state,
                masterCompany: {
                    data: payload,
                    isLoading: false,
                    status: 'ready'
                }
            };
        case REQUEST_MASTER_COMPANY_FAILURE:
            return {
                ...state,
                masterCompany: {
                    data: [],
                    isLoading: false,
                    status: 'failure'
                }
            }
        default:
            return state;
    }
}
